/*
  grove-screen-fit.js — exact screen-fit for full-bleed sections (hero,
  subscribe). CSS alone can't know how much space the in-flow header occupies
  above a section, so measure each [data-grove-fill] element's document-top
  offset and expose it as --grove-fill-offset; the section's CSS subtracts it
  from 100svh.
*/
(function () {
  function fitGroveSections() {
    document.querySelectorAll('[data-grove-fill]').forEach(function (el) {
      var top = el.getBoundingClientRect().top + window.scrollY;
      el.style.setProperty('--grove-fill-offset', top + 'px');
    });
  }

  window.addEventListener('resize', fitGroveSections);
  window.addEventListener('load', fitGroveSections);
  document.addEventListener('shopify:section:load', fitGroveSections);
  fitGroveSections();
})();
